function CreatePayment(custom, args) {
	let {price, serverOrigin} = custom;
	let {data, actions} = args;

	return fetch(`${serverOrigin}/paypal/createpayment/`, {
		method: 'POST',
		credentials: 'include',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify({
			price: price,
		}),
	})
		.then(function (res) {
			return res.json();
		})
		.then(function (orderData) {
			return orderData.orderID;
		})
		.catch(err => {
			console.error('An error happeoned');
		});
}

export default CreatePayment;
